import API from '@config/api';

const getLogs = params => API.get('/statistics/cardsLog', {params});
const getStatistics = params => API.get('/statistics/cardsStatistics', {params});
const createStatisticsReport = payload =>
  API.post('/statistics/createCardsStatisticsReport', payload, {responseType: 'arraybuffer'});

export {getLogs, getStatistics, createStatisticsReport};
